'use client';

import { PageType } from '@stereoagency/constants';
import { ReactNode, createContext } from 'react';

export type SpecialPagesContextValue = {
  pages: Record<
    Exclude<PageType, PageType.CONTENT_PAGE>,
    {
      _id: string;
      href: string;
      title: string;
    } | null
  >;
};

export const SpecialPagesContext = createContext<SpecialPagesContextValue>({
  pages: {
    [PageType.EVENT_LISTING_PAGE]: null,
    [PageType.HOMEPAGE]: null,
    [PageType.JOB_LISTING_PAGE]: null,
    [PageType.NEWS_LISTING_PAGE]: null,
    [PageType.RESEARCH_GROUP_LISTING_PAGE]: null,
    [PageType.RESEARCH_PLATFORM_LISTING_PAGE]: null
  }
});

function SpecialPagesProvider({
  value,
  children
}: {
  value: SpecialPagesContextValue;
  children?: ReactNode;
}) {
  return (
    <SpecialPagesContext.Provider value={value}>
      {children}
    </SpecialPagesContext.Provider>
  );
}

export default SpecialPagesProvider;
